<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          `On the Match Options panel, the user will upload a file of student or staff records and the system will search for a batch that matches the records. Use the ellipse to drill into the match results. This will take the user to the batch profile page Details or Download.`,
          `Note: When using Advanced upload type do not include the file format header and footer.`,
          `The Process Details panel provides information about the batch processing stage. The user can also resolve any near matches by clicking the Resolve button in the Next Steps panel.`,
          `On the Download tab, the user can choose the match status to download by using the radio button. Download Options allows the user to choose Simple or Advanced download format. The Advanced button allows the user to select the delimiter type, the qualifier, the date format and whether to include the header and footer.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
